var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 63,
    viewBox: "0 0 103 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.25 61.2969C53.1406 63.4062 49.625 63.4062 47.5156 61.2969L1.8125 15.8281C-0.296875 13.4844 -0.296875 9.96875 1.8125 7.85938L7.20312 2.46875C9.3125 0.359375 12.8281 0.359375 15.1719 2.46875L51.5 38.5625L87.5938 2.46875C89.9375 0.359375 93.4531 0.359375 95.5625 2.46875L100.953 7.85938C103.062 9.96875 103.062 13.4844 100.953 15.8281L55.25 61.2969Z",
    fill: "#516393"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevron-down.eea3a9f9ed17fe4728ad885161e6548d.svg";
export { ForwardRef as ReactComponent };